import onResize from 'simple-element-resize-detector';
import { HereMapsService } from '..';
import { resizeMap } from './utils';

const { createDefaultLayers, H, engineType } = HereMapsService;

function isTrafficItem(data) {
  return !!data.TRAFFIC_ITEM_ID;
}

export const createDefaultMap = (refId) => {
  const layers = createDefaultLayers();
  const ref = document.getElementById(refId);
  const map = new H.Map(
    ref,
    layers.vector.normal.map,
    {
      pixelRatio: window.devicePixelRatio || 1,
      engineType,
    },
  );
  map.getBaseLayer().setMin(2);
  map.getBaseLayer().setMax(19);

  function setCursorStyle(style) {
    map.getViewPort().element.style.cursor = style;
  }

  function deductPointerStyle(event) {
    if (event && event.target && event.target.getData) {
      const data = event.target.getData();
      if (data && (data.clickable || isTrafficItem(data))) {
        setCursorStyle('pointer');
        return;
      }
    }
    setCursorStyle('auto');
  }

  /* eslint no-unused-vars:0 */
  const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
  const ui = H.ui.UI.createDefault(map, layers);
  onResize(ref, () => resizeMap(ui));
  map.addEventListener('pointermove', deductPointerStyle, false);
  return ui;
};

export const createMapOrderCreation = (refId) => {
  const defaultLayers = createDefaultLayers();
  const map = new H.Map(document.getElementById(refId),
    defaultLayers.vector.normal.map,
    {
      zoom: 1,
      pixelRatio: window.devicePixelRatio || 1,
      engineType,
    });
  map.getBaseLayer().setMin(2);
  map.getBaseLayer().setMax(19);

  window.addEventListener('resize', () => map.getViewPort().resize());
  const ui = H.ui.UI.createDefault(map, defaultLayers);
  return map;
};

export const createBehavior = (map) => new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
